import {
    dictionary,
    locale,
    _
} from 'svelte-i18n';
function setupI18n({ withLocale: _locale} = { withLocale: 'en-US' }) {
    dictionary.set({
        'en-US': {
            'landing': {
                'knowPrice': 'Let’s calculate your personal pricing plan',
                'followers': 'followers',
                'priceLabelLow1k': 'Get access from ${price}',
                'priceLabel': 'Get access for ${price}'
            }
        },
        'ru-RU': {
            'landing': {
                'knowPrice': 'Узнайте стоимость тарифа для вашего аккаунта прямо сейчас!',
                'followers': 'подписчиков',
                'priceLabelLow1k': 'Начать от {price}₽/мес',
                'priceLabel': 'Начать за {price}₽/мес'
            }
        },
    });
    locale.set(_locale);
}
export {
    _,
    setupI18n
};